import classNames from 'classnames/bind'
import Modal from 'apps/main/deprecated/components/common/Modal'
import { useEffect, useState } from 'react'
import { DetailGuide } from 'apps/main/libs/roadmap/ui-detail-guide'
import { useRouter } from 'next/router'
import { useWindowSize } from '@frontend-mono/shared/util-window-size'
import { Amplitude } from 'apps/main/libs/analytics/amplitude/data-access-amplitude'
import styles from './FrontendRoadmap.module.scss'
import { ReactComponent as Roadmap } from './frontend-roadmap-2023.svg'
import { RoadmapData } from './types'
import { ReactComponent as RoadmapSmall } from './frontend-roadmap-2023-small.svg'
import { useEnterRoadmap } from '../data-access-amplitude'

const cx = classNames.bind(styles)

type FrontendRoadmapProps = {
  roadmapData: RoadmapData
}

export const FrontendRoadmap = ({ roadmapData }: FrontendRoadmapProps) => {
  const { isMobileSize } = useWindowSize()
  const [open, setOpen] = useState(false)
  const [dataId, setDataId] = useState<string | null>(null)
  const roadmapNodeData = roadmapData?.[dataId ?? '']
  const router = useRouter()
  const { node } = router.query
  useEnterRoadmap()

  const handleClose = () => {
    router.push(router.pathname, undefined, { scroll: false, shallow: true })
    setOpen(false)
  }

  useEffect(() => {
    if (node) {
      setDataId(node as string)
      setOpen(true)
    }
  }, [node])

  useEffect(() => {
    const clickableGroup = document.querySelectorAll('g.roadmap-node')
    const handleClick = (dataNodeId: string | null) => {
      if (dataNodeId) {
        router.push(
          {
            pathname: router.pathname,
            query: { node: dataNodeId },
          },
          undefined,
          { scroll: false, shallow: true },
        )
        setDataId(dataNodeId)
        setOpen(true)
        Amplitude.logEventByCategory('click', 'roadmap_frontend2023_node', { nodeId: dataNodeId })
      }
    }

    clickableGroup.forEach((elem) => {
      const dataNodeId = elem.getAttribute('data-node-id')
      elem.addEventListener('click', () => handleClick(dataNodeId))
    })

    return () =>
      clickableGroup.forEach((elem) => {
        const dataNodeId = elem.getAttribute('data-node-id')
        elem.removeEventListener('click', () => handleClick(dataNodeId))
      })

    // useEffect deps로 router 불필요함
    // router 있는 경우 클릭시 마다 각 노드에 대해 removeEventListener, addEventListenr 동작해서 성능 이슈로 제거함
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileSize])

  return (
    <div className={cx('container')}>
      <div className={cx('centerBox')}>
        <div className={cx('memoBox')}>
          📌
          <p className={cx('memo')}> 각 섹션을 클릭해보고 무료 컨텐츠를 열람해보세요!</p>
        </div>

        {isMobileSize ? (
          <RoadmapSmall className={cx('clickable')} />
        ) : (
          <Roadmap className={cx('clickable')} />
        )}
        {roadmapNodeData && (
          <Modal open={open} onBackgroundClick={handleClose}>
            <DetailGuide {...roadmapNodeData} onCloseClick={handleClose} />
          </Modal>
        )}
      </div>
    </div>
  )
}
